<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      max-width="1040"
    >
      <v-card
        v-if="miBanner"
        class="modal-banner"
        
        target="_blank"
        color="white"
      >

        <v-img
          :src="miBanner.imageUrl"
          aspect-ratio="2.6"
        >
          <v-layout
            slot="placeholder"
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-progress-circular
              indeterminate
              color="#E42228"
            ></v-progress-circular>
          </v-layout>
          <v-layout
            wrap
            row
            fill-height
            ma-0
          >
            <v-toolbar
              class="py-0"
              flat
              dense
              color="transparent"
            >
              <v-spacer></v-spacer>
              <v-btn
                @click="dialog = !dialog"
                icon
                small
              >
                <i class="fa fa-close"></i>
              </v-btn>
            </v-toolbar>
              <a class="action-area" :href="miBanner.destino" target="_blank" rel="noopener noreferrer"></a>
              
   
          </v-layout>
        </v-img>
        <!-- <v-card-title class="headline">{{$i18n.locale}}</v-card-title>
        <v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn>
          <v-btn color="green darken-1" flat @click="dialog = false">Agree</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<style>
.modal-banner .v-toolbar__content {
  background: transparent;
}
a:hover,
a:focus {
  text-decoration: none;
}
a.action-area {
  display: block;
  height: 100%;
  width: 100%;
}
</style>

<script>
export default {
  computed: {
    lang(){
      
      return this.$i18n.locale
    },
    miBanner(){
      const lang = !this.lang ? null : this.lang
      if (!lang) {
        return null
      } else {
        return this.banners.find(banner=>banner.texto==lang)
      }
      
    }
  },
  data() {
    return {
      dialog: true,
      banners: [
        {
          datos: [
            {
              alto: 400,
              ancho: 1040,
              ratio: 2.6
            }
          ],
          destino:
            "https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=en&kutxabank=si",
          id: "banner-modal-intro__ahlc1",
          imageUrl:
            "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/img%2Fbanners%2Ftickets.kutxabank.es%2Fbanner-intro%2Fkutxabank_modal-intro__ahlc1__banner.jpg?alt=media&token=134f214f-8736-4bec-9ab9-0655b347c413",
          nombre: "Banner Intro EN",
          slug: "modal-intro",
          texto: "en",
          tipo: "banner"
        },
        {
          datos: [
            {
              alto: 400,
              ancho: 1040,
              ratio: 2.6
            }
          ],
          destino:
            "https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=eu&kutxabank=si",
          id: "banner-modal-intro__c4mxpg",
          imageUrl:
            "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/img%2Fbanners%2Ftickets.kutxabank.es%2Fbanner-intro%2Fkutxabank_modal-intro__c4mxpg__banner.jpg?alt=media&token=e36f1af8-8986-4aa4-8293-df5e1a24fae0",
          nombre: "Banner Intro EU",
          slug: "modal-intro",
          texto: "eu",
          tipo: "banner"
        },
        {
          datos: [
            {
              alto: 400,
              ancho: 1040,
              ratio: 2.6
            }
          ],
          destino:
            "https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=es&kutxabank=si",
          id: "banner-modal-intro__r4tsyd",
          imageUrl:
            "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/img%2Fbanners%2Ftickets.kutxabank.es%2Fbanner-intro%2Fkutxabank_modal-intro__r4tsyd__banner.jpg?alt=media&token=b2a65333-cefe-4ed8-9e0d-d416f7047996",
          nombre: "Banner Intro ES",
          texto: "es",
          slug: "modal-intro",
          tipo: "banner"
        },
        {
          datos: [
            {
              alto: 400,
              ancho: 1040,
              ratio: 2.6
            }
          ],
          destino:
            "https://portal.kutxabank.es/cs/Satellite?pagename=PortalKutxabank/Page/PK_BuscadorRecogidaEntradas&hizkuntza=fr&kutxabank=si",
          id: "banner-modal-intro__y561mj",
          imageUrl:
            "https://firebasestorage.googleapis.com/v0/b/jmdb-production.appspot.com/o/img%2Fbanners%2Ftickets.kutxabank.es%2Fbanner-intro%2Fkutxabank_modal-intro__y561mj__banner.jpg?alt=media&token=78ebf63a-9a84-464d-b28d-4e19021d3807",
          nombre: "Banner Intro FR",
          slug: "modal-intro",
          texto: "fr",
          tipo: "banner"
        }
      ]
    };
  }
};
</script>